import Vue from "vue";
import { newLogger } from "@/utils/util";
import axios from "axios";
import network from "../../../utils/network";

let logger = newLogger("AcceptanceRequirementsStore");

const urls = {
  registration: "/api/administration/registration-acceptance", // GET
  calculation: "/administration/calculation-acceptance", // GET
  accept: "/statement/accept", // POST
};

/**
 * Administration Registration Page Configuration store
 */

const initState = () => {
  return {
    regConfig: [],
    calcConfig: [],
  };
};

const actions = {
  fetchRegConfig: async ({ commit }) => {
    try {
      let { data } = await axios.get(urls.registration);
      commit("saveReg", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  fetchCalcConfig: async ({ commit }) => {
    try {
      let axios = await network.connection();
      let { data } = await axios.get(urls.calculation);
      commit("saveCalc", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  acceptStatement: async (_, request) => {
    try {
      let axios = await network.connection();
      await axios.post(urls.accept, request);
      return true;
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
};

const mutations = {
  saveReg: (state, configurations) => {
    Vue.set(state, "regConfig", configurations);
  },
  saveCalc: (state, configurations) => {
    Vue.set(state, "calcConfig", configurations);
  },
};

const getters = {
  regConfig: (state) => {
    return state.regConfig;
  },
  calcConfig: (state) => {
    return state.calcConfig;
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations,
  actions,
  getters,
};
